import React from 'react'
import { Link } from 'react-router-dom'

import useAuth from 'store/AuthContext'
import Profile from 'components/Icons/profile'
import { ProfileAvatar } from '../Header.style'

const UserProfile = ({ isMobile = false, onClick }) => {
  const { setLoginModalShow, auth, user } = useAuth()

  const handleClick = e => {
    if (auth) {
      if (onClick) onClick(e)
      return
    }
    e.preventDefault()
    setLoginModalShow(true)
  }

  const avatarContent = auth ? (
    user.name.charAt(0).toUpperCase()
  ) : (
    <Profile
      width={20}
      height={20}
      color="white"
      className="mb-[1px] md:mb-0"
    />
  )
  const userName = auth ? user.name : 'პროფილი'

  const mobileStyles = 'cursor-pointer'
  const desktopStyles =
    'flex items-center gap-2 py-2 px-3 bg-blue-50 rounded-full border border-blue-200 text-sm text-blue-900 cursor-pointer'

  if (isMobile) {
    return (
      <Link to="/account/orders" onClick={handleClick} className={mobileStyles}>
        <ProfileAvatar>{avatarContent}</ProfileAvatar>
      </Link>
    )
  }

  return (
    <Link to="/account/orders" onClick={handleClick} className={desktopStyles}>
      <ProfileAvatar>{avatarContent}</ProfileAvatar>
      <span>{userName}</span>
    </Link>
  )
}

export default UserProfile
